"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function Tool(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (react_1.default.createElement("svg", { className: "icon ".concat(className), height: "".concat(height), viewBox: "0 0 64 64", width: "".concat(width) },
        react_1.default.createElement("path", { d: "M36.0117 39.137L40.784 34.3648L54.275 47.8558L49.5027 52.628L36.0117 39.137ZM44.375 27.5C48.7175 27.5 52.25 23.9675 52.25 19.625C52.25 18.32 51.89 17.105 51.3275 16.025L45.2525 22.1L41.9 18.7475L47.975 12.6725C46.895 12.11 45.68 11.75 44.375 11.75C40.0325 11.75 36.5 15.2825 36.5 19.625C36.5 20.5475 36.68 21.425 36.9725 22.235L32.81 26.3975L28.805 22.3925L30.4025 20.795L27.23 17.6225L32 12.8525C30.7343 11.5884 29.0187 10.8784 27.23 10.8784C25.4412 10.8784 23.7256 11.5884 22.46 12.8525L14.495 20.8175L17.6675 23.99H11.3225L9.72498 25.5875L17.69 33.5525L19.2875 31.955V25.5875L22.46 28.76L24.0575 27.1625L28.0625 31.1675L11.39 47.84L16.16 52.61L41.765 27.0275C42.575 27.32 43.4525 27.5 44.375 27.5Z", fill: "black" })));
}
Tool.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
Tool.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = Tool;
